import React from 'react';
import { Icon } from '../Icon';
import type { IconProps } from '../.types/IconPropsType';

export function ArrowUpIcon(props: IconProps) {
  return (
    <Icon {...props}>
      <svg
        width="16"
        height="16"
        viewBox="0 0 14 16"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path d="M0.999989 6C0.61339 6.3866 0.613388 7.0134 0.999988 7.4C1.38659 7.7866 2.01339 7.7866 2.39999 7.4L5.99999 3.8V15C5.99999 15.5523 6.4477 16 6.99999 16C7.55227 16 7.99999 15.5523 7.99999 15V3.8L11.6 7.4C11.9866 7.7866 12.6134 7.7866 13 7.4C13.3866 7.0134 13.3866 6.3866 13 6L7.7071 0.707107C7.31657 0.316583 6.6834 0.316583 6.29288 0.707107L0.999989 6Z" />
      </svg>
    </Icon>
  );
}
